import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import Header from "../layouts/Headerfour";
import Breadcrumb from "../layouts/Breadcrumb";
import Footer from "../layouts/Footerthree";
import Content from "../sections/services/Content";
import DistressContent from "../sections/services/DistressContent";
import { useTranslation } from "react-i18next";

const Distress = () => {
  const {t} = useTranslation();

  return (
    <Fragment>
      <Helmet>
        <title>
          Buy Home For Less | Help With Distress Home
        </title>
        <meta name="description" content="#" />
      </Helmet>
      <Header />
      <Breadcrumb breadcrumb={{ pagename: t("Help With Distress Home") }} />
      <div className="marginHomeContent">
        <DistressContent/>
      </div>
      <Footer />
    </Fragment>
  );
};

export default Distress;
